var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { useSwipeable } from 'react-swipeable';
import { ArrowLeftIcon, ArrowRightIcon } from '../../icons/icons';
import { Card } from './Card';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-fr24j0" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n"])));
var CardOutterContainer = styled.div.withConfig({ displayName: "CardOutterContainer", componentId: "sc-1p6hxda" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: 40px;\n  & > :first-child {\n    align-self: start;\n    margin-right: 20px;\n    margin-top: 5px;\n  }\n  & > :last-child {\n    align-self: start;\n    margin-left: 20px;\n    margin-top: 5px;\n  }\n\n  ", " {\n    margin-bottom: 0;\n  }\n\n  ", " {\n    margin-bottom: 44px;\n  }\n"], ["\n  display: flex;\n  margin-bottom: 40px;\n  & > :first-child {\n    align-self: start;\n    margin-right: 20px;\n    margin-top: 5px;\n  }\n  & > :last-child {\n    align-self: start;\n    margin-left: 20px;\n    margin-top: 5px;\n  }\n\n  ", " {\n    margin-bottom: 0;\n  }\n\n  ", " {\n    margin-bottom: 44px;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
}, function (_a) {
    var down = _a.theme.down;
    return down('phone');
});
var CardContainer = styled.div.withConfig({ displayName: "CardContainer", componentId: "sc-teirj3" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  width: ", ";\n  overflow: hidden;\n"], ["\n  display: flex;\n  width: ", ";\n  overflow: hidden;\n"])), function (_a) {
    var width = _a.width;
    return width + "px";
});
var ScCard = styled(Card).withConfig({ displayName: "ScCard", componentId: "sc-1g9w9cd" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &:not(:last-child) {\n    margin-right: 16px;\n  }\n  transform: ", ";\n  transition: transform 0.7s linear;\n"], ["\n  &:not(:last-child) {\n    margin-right: 16px;\n  }\n  transform: ", ";\n  transition: transform 0.7s linear;\n"])), function (_a) {
    var position = _a.position;
    return "translateX(" + position + "px)";
});
var ArrowButton = styled.button.withConfig({ displayName: "ArrowButton", componentId: "sc-51wpsi" })(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 8px 12px;\n  background: transparent;\n  border: unset;\n  line-height: 0;\n\n  ", " {\n    display: none;\n  }\n"], ["\n  padding: 8px 12px;\n  background: transparent;\n  border: unset;\n  line-height: 0;\n\n  ", " {\n    display: none;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('phone');
});
var Slider = function (_a) {
    var cards = _a.cards, maxWidth = _a.maxWidth, _b = _a.cardsPerPage, cardsPerPage = _b === void 0 ? 3 : _b, rest = __rest(_a, ["cards", "maxWidth", "cardsPerPage"]);
    var maxPosition = Math.ceil(cards.length / cardsPerPage) - 1;
    var _c = useState(0), position = _c[0], setPosition = _c[1];
    var onPickerChange = useCallback(function (position) {
        setPosition(position);
    }, []);
    var onLeftChange = useCallback(function () {
        setPosition(position === 0 ? maxPosition : position - 1);
    }, [position, maxPosition]);
    var onRightChange = useCallback(function () {
        setPosition(position === maxPosition ? 0 : position + 1);
    }, [position, maxPosition]);
    var swipeableRef = useSwipeable({
        onSwipedLeft: onRightChange,
        onSwipedRight: onLeftChange,
    }).ref;
    var _d = useState(false), isLoaded = _d[0], setIsLoaded = _d[1];
    useEffect(function () {
        var timeout = setTimeout(function () {
            setIsLoaded(true);
        }, 500);
        return function () { return clearTimeout(timeout); };
    }, []);
    if (!isLoaded)
        return _jsx("div", {}, void 0);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsxs(CardOutterContainer, { children: [_jsx(ArrowButton, __assign({ onClick: onLeftChange, type: 'button' }, { children: _jsx(ArrowLeftIcon, {}, void 0) }), void 0), _jsx(CardContainer, __assign({ ref: swipeableRef, width: maxWidth - 16 }, { children: isLoaded &&
                            cards.map(function (card) { return (_jsx(ScCard, { card: card, position: -maxWidth * position }, card.id)); }) }), void 0), _jsx(ArrowButton, __assign({ onClick: onRightChange, type: 'button' }, { children: _jsx(ArrowRightIcon, {}, void 0) }), void 0)] }, void 0), _jsx(ScPicker, { count: cards.length / cardsPerPage, onChange: onPickerChange, currentPosition: position }, void 0)] }), void 0));
};
var PickerContainer = styled.div.withConfig({ displayName: "PickerContainer", componentId: "sc-ve3grw" })(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Circle = styled.div.withConfig({ displayName: "Circle", componentId: "sc-qdm30i" })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #42abe9;\n  opacity: ", ";\n\n  &:not(:last-child) {\n    margin-right: 15px;\n  }\n\n  ", ";\n"], ["\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #42abe9;\n  opacity: ", ";\n\n  &:not(:last-child) {\n    margin-right: 15px;\n  }\n\n  ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.3 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "cursor: pointer;";
});
var Picker = function (_a) {
    var count = _a.count, _b = _a.currentPosition, currentPosition = _b === void 0 ? 0 : _b, onChange = _a.onChange, rest = __rest(_a, ["count", "currentPosition", "onChange"]);
    var maxCount = Math.min(count, 8);
    var circles = [];
    var _loop_1 = function (index) {
        var isDisabled = index !== currentPosition;
        circles.push(_jsx(Circle, { disabled: isDisabled, onClick: function () {
                if (isDisabled)
                    onChange(index);
            } }, index.toString()));
    };
    for (var index = 0; index < maxCount; index++) {
        _loop_1(index);
    }
    return _jsx(PickerContainer, __assign({}, rest, { children: circles }), void 0);
};
var ScPicker = styled(Picker).withConfig({ displayName: "ScPicker", componentId: "sc-uv2au9" })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: flex;\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n  ", " {\n    display: flex;\n  }\n"])), function (_a) {
    var down = _a.theme.down;
    return down('tablet');
}, function (_a) {
    var down = _a.theme.down;
    return down('phone');
});
export { Slider };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
